"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftMatchProfileDto = instanceOfShiftMatchProfileDto;
exports.ShiftMatchProfileDtoFromJSON = ShiftMatchProfileDtoFromJSON;
exports.ShiftMatchProfileDtoFromJSONTyped = ShiftMatchProfileDtoFromJSONTyped;
exports.ShiftMatchProfileDtoToJSON = ShiftMatchProfileDtoToJSON;
exports.ShiftMatchProfileDtoToJSONTyped = ShiftMatchProfileDtoToJSONTyped;
const NurseSpecialtyDto_1 = require("./NurseSpecialtyDto");
/**
 * Check if a given object implements the ShiftMatchProfileDto interface.
 */
function instanceOfShiftMatchProfileDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
function ShiftMatchProfileDtoFromJSON(json) {
    return ShiftMatchProfileDtoFromJSONTyped(json, false);
}
function ShiftMatchProfileDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'avatar': json['avatar'] == null ? undefined : json['avatar'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'specialties': json['specialties'] == null ? undefined : (json['specialties'].map(NurseSpecialtyDto_1.NurseSpecialtyDtoFromJSON)),
        'isVerifiedAtFacility': json['isVerifiedAtFacility'] == null ? undefined : json['isVerifiedAtFacility'],
    };
}
function ShiftMatchProfileDtoToJSON(json) {
    return ShiftMatchProfileDtoToJSONTyped(json, false);
}
function ShiftMatchProfileDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'avatar': value['avatar'],
        'phoneNumber': value['phoneNumber'],
        'specialties': value['specialties'] == null ? undefined : (value['specialties'].map(NurseSpecialtyDto_1.NurseSpecialtyDtoToJSON)),
        'isVerifiedAtFacility': value['isVerifiedAtFacility'],
    };
}
//# sourceMappingURL=ShiftMatchProfileDto.js.map